// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as InvestitoriRouteImport } from './routes/investitori'
import { Route as EnRouteImport } from './routes/en'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CareerRouteImport } from './routes/career'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NewsIndexRouteImport } from './routes/news/index'
import { Route as NewsIdRouteImport } from './routes/news/$id'
import { Route as AboutUpravenOdborRouteImport } from './routes/about_.upraven-odbor'
import { Route as AboutPovazniAktiRouteImport } from './routes/about_.povazni-akti'
import { Route as AboutOrganizaciskaStrukturaRouteImport } from './routes/about_.organizaciska-struktura'
import { Route as AboutNadzorenOdborRouteImport } from './routes/about_.nadzoren-odbor'
import { Route as AboutHotelskiMenadzmentRouteImport } from './routes/about_.hotelski-menadzment'
import { Route as EnIndexRouteImport } from './routes/en/index'
import { Route as EnTermsOfServiceRouteImport } from './routes/en/terms-of-service'
import { Route as EnPrivacyPolicyRouteImport } from './routes/en/privacy-policy'
import { Route as EnInvestitoriRouteImport } from './routes/en/investitori'
import { Route as EnContactRouteImport } from './routes/en/contact'
import { Route as EnCareerRouteImport } from './routes/en/career'
import { Route as EnAboutRouteImport } from './routes/en/about'
import { Route as EnNewsIndexRouteImport } from './routes/en/news/index'
import { Route as EnNewsIdRouteImport } from './routes/en/news/$id'
import { Route as EnAboutUpravenOdborRouteImport } from './routes/en/about_.upraven-odbor'
import { Route as EnAboutPovazniAktiRouteImport } from './routes/en/about_.povazni-akti'
import { Route as EnAboutOrganizaciskaStrukturaRouteImport } from './routes/en/about_.organizaciska-struktura'
import { Route as EnAboutNadzorenOdborRouteImport } from './routes/en/about_.nadzoren-odbor'
import { Route as EnAboutHotelskiMenadzmentRouteImport } from './routes/en/about_.hotelski-menadzment'

const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const MenuRoute = MenuRouteImport.update({
            id: '/menu',path: '/menu',getParentRoute: () => rootRouteImport
          })
const InvestitoriRoute = InvestitoriRouteImport.update({
            id: '/investitori',path: '/investitori',getParentRoute: () => rootRouteImport
          })
const EnRoute = EnRouteImport.update({
            id: '/en',path: '/en',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CareerRoute = CareerRouteImport.update({
            id: '/career',path: '/career',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const NewsIndexRoute = NewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => rootRouteImport
          })
const NewsIdRoute = NewsIdRouteImport.update({
            id: '/news/$id',path: '/news/$id',getParentRoute: () => rootRouteImport
          })
const AboutUpravenOdborRoute = AboutUpravenOdborRouteImport.update({
            id: '/about_/upraven-odbor',path: '/about/upraven-odbor',getParentRoute: () => rootRouteImport
          })
const AboutPovazniAktiRoute = AboutPovazniAktiRouteImport.update({
            id: '/about_/povazni-akti',path: '/about/povazni-akti',getParentRoute: () => rootRouteImport
          })
const AboutOrganizaciskaStrukturaRoute = AboutOrganizaciskaStrukturaRouteImport.update({
            id: '/about_/organizaciska-struktura',path: '/about/organizaciska-struktura',getParentRoute: () => rootRouteImport
          })
const AboutNadzorenOdborRoute = AboutNadzorenOdborRouteImport.update({
            id: '/about_/nadzoren-odbor',path: '/about/nadzoren-odbor',getParentRoute: () => rootRouteImport
          })
const AboutHotelskiMenadzmentRoute = AboutHotelskiMenadzmentRouteImport.update({
            id: '/about_/hotelski-menadzment',path: '/about/hotelski-menadzment',getParentRoute: () => rootRouteImport
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnRoute
          })
const EnTermsOfServiceRoute = EnTermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => EnRoute
          })
const EnPrivacyPolicyRoute = EnPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => EnRoute
          })
const EnInvestitoriRoute = EnInvestitoriRouteImport.update({
            id: '/investitori',path: '/investitori',getParentRoute: () => EnRoute
          })
const EnContactRoute = EnContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => EnRoute
          })
const EnCareerRoute = EnCareerRouteImport.update({
            id: '/career',path: '/career',getParentRoute: () => EnRoute
          })
const EnAboutRoute = EnAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => EnRoute
          })
const EnNewsIndexRoute = EnNewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => EnRoute
          })
const EnNewsIdRoute = EnNewsIdRouteImport.update({
            id: '/news/$id',path: '/news/$id',getParentRoute: () => EnRoute
          })
const EnAboutUpravenOdborRoute = EnAboutUpravenOdborRouteImport.update({
            id: '/about_/upraven-odbor',path: '/about/upraven-odbor',getParentRoute: () => EnRoute
          })
const EnAboutPovazniAktiRoute = EnAboutPovazniAktiRouteImport.update({
            id: '/about_/povazni-akti',path: '/about/povazni-akti',getParentRoute: () => EnRoute
          })
const EnAboutOrganizaciskaStrukturaRoute = EnAboutOrganizaciskaStrukturaRouteImport.update({
            id: '/about_/organizaciska-struktura',path: '/about/organizaciska-struktura',getParentRoute: () => EnRoute
          })
const EnAboutNadzorenOdborRoute = EnAboutNadzorenOdborRouteImport.update({
            id: '/about_/nadzoren-odbor',path: '/about/nadzoren-odbor',getParentRoute: () => EnRoute
          })
const EnAboutHotelskiMenadzmentRoute = EnAboutHotelskiMenadzmentRouteImport.update({
            id: '/about_/hotelski-menadzment',path: '/about/hotelski-menadzment',getParentRoute: () => EnRoute
          })





const EnRouteChildren = {
  EnAboutRoute: EnAboutRoute,EnCareerRoute: EnCareerRoute,EnContactRoute: EnContactRoute,EnInvestitoriRoute: EnInvestitoriRoute,EnPrivacyPolicyRoute: EnPrivacyPolicyRoute,EnTermsOfServiceRoute: EnTermsOfServiceRoute,EnIndexRoute: EnIndexRoute,EnAboutHotelskiMenadzmentRoute: EnAboutHotelskiMenadzmentRoute,EnAboutNadzorenOdborRoute: EnAboutNadzorenOdborRoute,EnAboutOrganizaciskaStrukturaRoute: EnAboutOrganizaciskaStrukturaRoute,EnAboutPovazniAktiRoute: EnAboutPovazniAktiRoute,EnAboutUpravenOdborRoute: EnAboutUpravenOdborRoute,EnNewsIdRoute: EnNewsIdRoute,EnNewsIndexRoute: EnNewsIndexRoute
}

const EnRouteWithChildren = EnRoute._addFileChildren(EnRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CareerRoute: CareerRoute,ContactRoute: ContactRoute,EnRoute: EnRouteWithChildren,InvestitoriRoute: InvestitoriRoute,MenuRoute: MenuRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TermsOfServiceRoute: TermsOfServiceRoute,AboutHotelskiMenadzmentRoute: AboutHotelskiMenadzmentRoute,AboutNadzorenOdborRoute: AboutNadzorenOdborRoute,AboutOrganizaciskaStrukturaRoute: AboutOrganizaciskaStrukturaRoute,AboutPovazniAktiRoute: AboutPovazniAktiRoute,AboutUpravenOdborRoute: AboutUpravenOdborRoute,NewsIdRoute: NewsIdRoute,NewsIndexRoute: NewsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)